import { cva } from 'class-variance-authority';
import { ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { ButtonBaseProps } from '../helpers/button.types';
import { ButtonCompoundVariants } from '../helpers/buttons.constants';

const buttonsVariants = cva(
    [
        'inline-flex items-center justify-center',
        'whitespace-nowrap',
        'font-semibold',
        'rounded-full',
        'shadow-[0px_2px_4px_rgba(0,0,0,0.1),0px_2px_8px_rgba(0,0,0,0.1)]',
        'cursor-pointer',
    ],
    {
        variants: {
            color: {
                primary: [],
                secondary: [],
                success: [],
                danger: [],
                warning: [],
            },
            variant: {
                default: [],
                shaded: [],
            },
            size: {
                xs: ['text-xs h-8 w-8'],
                sm: ['text-sm h-9 w-9'],
                normal: ['text-sm h-10 w-10'],
                lg: ['text-base h-11 w-11'],
                xl: ['text-lg h-12 w-12'],
            },
        },
        compoundVariants: ButtonCompoundVariants,
        defaultVariants: {
            color: 'primary',
            variant: 'default',
            size: 'normal',
        },
    }
);

interface FloatingButtonProps extends ButtonBaseProps<typeof buttonsVariants> {
    ref?: ForwardedRef<HTMLButtonElement>;
}

const FloatingButton = forwardRef<HTMLButtonElement, FloatingButtonProps>((props, ref) => {
    const { children, variant, color, size, className, ...rest } = props;

    return (
        <button {...rest} ref={ref} className={twMerge(buttonsVariants({ color, variant, size, className }))}>
            {children}
        </button>
    );
});

export default FloatingButton;
